import { render, staticRenderFns } from "./ProductBrochure.vue?vue&type=template&id=11ba867d&scoped=true&"
import script from "./ProductBrochure.vue?vue&type=script&lang=js&"
export * from "./ProductBrochure.vue?vue&type=script&lang=js&"
import style0 from "./ProductBrochure.vue?vue&type=style&index=0&id=11ba867d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba867d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ba867d')) {
      api.createRecord('11ba867d', component.options)
    } else {
      api.reload('11ba867d', component.options)
    }
    module.hot.accept("./ProductBrochure.vue?vue&type=template&id=11ba867d&scoped=true&", function () {
      api.rerender('11ba867d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/ProductBrochure/ProductBrochure.vue"
export default component.exports